import { styled } from '@mui/material';
import { CoreTypography } from '@youscience/core';
import { coreThemeColors } from '@youscience/theme';

const errorColor = '#FF4949';

export const sxStyles = {
  textFieldWrap: {
    width: '85%',
  },
  formHelperText: {
    '& .MuiFormHelperText-root': {
      marginRight: '2rem',
    },
  },
};

export const StyledCustomCheckpointCheckBox = styled('div')(() => ({
  display: 'flex',
  marginTop: '0.5rem',
  marginBottom: '0.5rem',

  '& > p:first-of-type': {
    marginTop: '0.125rem',
  },
}));

export const StyledTextFieldCounter = styled(CoreTypography, {
  shouldForwardProp: (prop) => prop !== 'isError',
})<{ isError?: boolean }>(({ isError, theme }) => ({
  position: 'absolute',
  right: 0,
  top: '2.5rem',
  color: isError ? errorColor : theme.palette.grey['700'],
}));

export const StyledTextFieldIcons = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const StyledActionIcon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  marginLeft: '0.625rem',
  cursor: 'pointer',
  borderRadius: '40px',

  '&:hover': {
    backgroundColor: theme.palette.grey[100],
  },
}));
